import { Box, Skeleton } from "@mui/material";

import {
  gridColumnsSx,
  TILE_CAPTION_SX,
  TILE_CARD_SX,
  type ColumnCount,
} from "./tileStyles";

export function LoadingSkeletonGrid({ columns }: { columns: ColumnCount }) {
  return (
    <Box
      data-testid="generated-thumbnail-grid-loading"
      sx={gridColumnsSx(columns)}
    >
      {Array.from({ length: columns * 2 }, (_unused, index) => (
        <SkeletonTile key={index} />
      ))}
    </Box>
  );
}

function SkeletonTile() {
  return (
    <Box data-testid="generated-tile-skeleton-card" sx={TILE_CARD_SX}>
      <Skeleton
        variant="rectangular"
        sx={{ width: "100%", aspectRatio: "4 / 3" }}
      />
      <Box sx={TILE_CAPTION_SX}>
        <Skeleton variant="text" width="70%" />
        <Skeleton variant="text" width="40%" />
      </Box>
    </Box>
  );
}
